import { IPet } from "./models";
import { HttpClient } from "../HttpClient";

export default class PetsHttpClient {
  static create(pet: IPet): Promise<IPet> {
    return HttpClient.post<IPet>("pets/", pet);
  }
}
